import { Field } from 'react-final-form';
import { FormControlLabel, Radio } from '@material-ui/core';
import styled from 'styled-components';
import { required } from '../../../../utils/validators';
import { SIGNUP_FLOORING_METHODS } from '../../../../constants';
import { FormRadioGroup } from 'components';

const StyledFormControlLabel = styled(FormControlLabel)`
  & > span:last-child {
    font-size: 12px;
    line-height: 14.06px;
    color: #939393;
    margin-left: -6px;
  }
`;

const FlooringMethodPicker = () => (
  <>
    <Field name="flooring_upload_method" component={FormRadioGroup} validate={required}>
      <StyledFormControlLabel
        value={SIGNUP_FLOORING_METHODS.ENTER_FLOORING_INFORMATION}
        control={<Radio color="primary" />}
        label="Enter Flooring Information"
        error
      />
      <StyledFormControlLabel
        value={SIGNUP_FLOORING_METHODS.PROVIDE_INFO_LATER}
        control={<Radio color="primary" />}
        label="Provide Information Later"
      />
    </Field>
  </>
);

export default FlooringMethodPicker;
